const MAX_NAME_LENGTH = 100;

function validate(firstName: string, lastName: string) {
  const trimmedFirstName = firstName.trim();
  const trimmedLastName = lastName.trim();

  if (!trimmedFirstName || !trimmedLastName) {
    throw new Error('First name and last name cannot be empty.');
  }

  if (trimmedFirstName.length > MAX_NAME_LENGTH || trimmedLastName.length > MAX_NAME_LENGTH) {
    throw new Error('First name and last name should be less than 100 characters.');
  }
}

export default validate;
